/**
 * FORCE-RESEED-PRESERVE-USER-DATA-1 (Option B)
 *
 * Collections in this Set may be wiped and re-seeded when SEED_VERSION bumps.
 * Collections NOT in this Set are never cleared by forceReseed — their data
 * is either entirely user-created (USER_OWNED) or seed-plus-user (USER_AUGMENTED).
 *
 * To add a new collection to the allowlist it must be DEMO_FIXTURE category:
 * seed data is the full population, no user records are expected to persist.
 *
 * USER_OWNED (never wipe): doc_feedback, cruise_provisioning_plans
 * USER_AUGMENTED (never wipe): notifications, doc_parse_jobs, loadboard_postings,
 *   loadboard_quotes, disputes, report_runs, proactive_notifications, crm_accounts,
 *   crm_contacts, crm_deals, crm_activities, marpol_records
 */
export const FORCE_RESEED_ALLOWED = new Set([
  'customers',
  'carriers',
  'loads',
  'quotes',
  'purchaseOrders',
  'appointments',
  'carrierVetting',
  'iot_trackers',
  'iot_events',
  'assets',
  'trucks',
  'financials',
  'events',
  'exceptions',
  'inventory',
  'fleet_vehicles',
  'fleet_drivers',
  'fleet_maintenance',
  'fleet_compliance',
  'aegis_actions',
  'aegis_predictions',
  'aegis_agents',
  'aegis_agent_events',
  'aegis_negotiations',
  'voice_calls',
  'aegis_risk_events',
  'aegis_country_risk',
  'aegis_user_activity',
  'aegis_performance_profiles',
  'aegis_coaching_insights',
  'aegis_performance_goals',
  'carrier_compliance',
  'quote_outcomes',
  'quote_templates',
  'doc_parse_results',
  'wms_picks',
  'rate_confirmations',
  // TMS-AUTOSEED-SEAT-F-PARITY-1 — spot_bids is DEMO_FIXTURE; safe to wipe on version bump
  'spot_bids',
  'carrier_invoices',
  'consolidation_opportunities',
  'consolidation_outcomes',
  'dispatch_autonomy_rules',
  'agent_dispatch_log',
  'carrier_trust_scores',
  'carrier_alerts',
  'carrier_vetting_history',
  'exception_predictions',
  'daily_ops_briefs',
  'hs_classifications',
  'tariff_alerts',
  'landed_cost_snapshots',
  'emissions_factors',
  'emissions_reports',
  'scenarios',
  'customs_documents',
  'carrier_allocation_rules',
  'report_schedules',
  'edi_messages',
  'carrier_onboarding_applications',
  'carrier_rate_tables',
  'carrier_contracts',
  'rate_confirmations_tms11',
  'ltl_rate_quotes',
  'ltl_pro_tracking',
  'nps_surveys',
  'csat_surveys',
  'customer_onboarding_applications',
  'customer_contracts',
  'crm_demo_sends',
  'crm_demo_engagement',
  'crm_prospect_mirrors',
  'connectors',
  'connector_sync_logs',
  'connector_field_maps',
  'cruise_sailings',
  'cruise_recipes',
  'cruise_consumption',
  'retailer_compliance_profiles',
  'specifier_projects',
]);
